// extracted by mini-css-extract-plugin
export default {"muradi-dahb-nav":"Sidebar_muradi-dahb-nav__AXPnv","member-info":"Sidebar_member-info__PcDLd"};